"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../../Clients/Avatar"));
var _Name = _interopRequireDefault(require("../../Clients/Name"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// TODO: вынести типизацию менеджера при рефакторинге ЦРМ

var TicketViewingManagersList = function TicketViewingManagersList(_ref) {
  var className = _ref.className,
    managers = _ref.managers,
    viewingManagersIds = _ref.viewingManagersIds;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    viewingManagers = _useState2[0],
    setViewingManagers = _useState2[1];
  (0, _react.useEffect)(function () {
    var filteredManagers = managers.filter(function (manager) {
      return viewingManagersIds.includes(manager.id);
    });
    setViewingManagers(filteredManagers);
  }, [viewingManagersIds]);
  if (!viewingManagersIds || !viewingManagersIds.length) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledTicketViewingManagersListWrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, "\u041F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u044E\u0442 \u0432 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442:"), /*#__PURE__*/_react["default"].createElement(StyledViewingManagersWrapper, null, viewingManagers.map(function (manager) {
    return /*#__PURE__*/_react["default"].createElement(StyledViewingManager, null, /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
      name: manager.name,
      url: manager.avatarUrl
    }), /*#__PURE__*/_react["default"].createElement(StyledName, {
      name: manager.name
    }));
  })));
};
var StyledTicketViewingManagersListWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TicketViewingManagersList__StyledTicketViewingManagersListWrapper",
  componentId: "sc-1u8z363-0"
})(["padding:5px 0;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "TicketViewingManagersList__StyledTitle",
  componentId: "sc-1u8z363-1"
})(["font-size:12px;color:rgb(145,148,153);margin-bottom:8px;"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "TicketViewingManagersList__StyledName",
  componentId: "sc-1u8z363-2"
})(["font-size:14px;font-weight:300;"]);
var StyledViewingManagersWrapper = _styledComponents["default"].ul.withConfig({
  displayName: "TicketViewingManagersList__StyledViewingManagersWrapper",
  componentId: "sc-1u8z363-3"
})(["list-style:none;margin-left:6px;"]);
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "TicketViewingManagersList__StyledAvatar",
  componentId: "sc-1u8z363-4"
})([""]);
var StyledViewingManager = _styledComponents["default"].li.withConfig({
  displayName: "TicketViewingManagersList__StyledViewingManager",
  componentId: "sc-1u8z363-5"
})(["align-items:center;display:flex;&:not(:last-of-type){margin-bottom:5px;}", "{height:18px;width:18px;}", "{margin-left:6px;}"], StyledAvatar, StyledName);
var _default = exports["default"] = TicketViewingManagersList;